import DropdownOption from "../dropdownOption";

export const DepositoryCityList: DropdownOption[] = [
    {
        value: "5035",
        text: "Boston",
        isSelected: false
    },
    {
        value: "5044",
        text: "Brockton",
        isSelected: false
    },
    {
        value: "5049",
        text: "Cambridge",
        isSelected: false
    },
    {
        value: "5095",
        text: "Fall River",
        isSelected: false
    },
    {
        value: "5100",
        text: "Framingham",
        isSelected: false
    },
    {
        value: "5128",
        text: "Haverhill",
        isSelected: false
    },
    {
        value: "5165",
        text: "Malden",
        isSelected: false
    },
    {
        value: "5149",
        text: "Lawrence",
        isSelected: false
    },
    {
        value: "5160",
        text: "Lowell",
        isSelected: false
    },
    {
        value: "5163",
        text: "Lynn",
        isSelected: false
    },
    {
        value: "5201",
        text: "New Bedford",
        isSelected: false
    },
    {
        value: "5207",
        text: "Newton",
        isSelected: false
    },
    {
        value: "5243",
        text: "Quincy",
        isSelected: false
    },
    {
        value: "5274",
        text: "Somerville",
        isSelected: false
    },
    {
        value: "5281",
        text: "Springfield",
        isSelected: false
    },
    {
        value: "5308",
        text: "Waltham",
        isSelected: false
    },
    {
        value: "5348",
        text: "Worcester",
        isSelected: false
    }
]